import { Text } from '@kubit-ui-web/react-components';
import styled from 'styled-components';

/**
 * App footer, required to credit the Kubit UI library.
 *
 * Kubit ships a `Footer` component, but it is a heavy site-chrome widget aimed
 * at legal links and column layouts — overkill for a single credit line, and
 * untyped here. A styled `<footer>` with Kubit's own `Text` keeps the credit
 * in the theme's type scale without pulling that weight in.
 */
const Bar = styled.footer`
  margin-top: auto;
  padding-top: 1.5rem;
  border-top: 1px solid rgba(0, 0, 0, 0.12);
  text-align: center;
`;

const Credit = styled.a`
  color: inherit;
  font-weight: 600;
  text-decoration: underline;
`;

export function AppFooter() {
  return (
    <Bar>
      <Text variant="PARAGRAPH_CAPTION_EXPANDED" component="p">
        UI made with{' '}
        <Credit href="https://www.kubit-ui.com" target="_blank" rel="noreferrer noopener">
          Kubit UI
        </Credit>
      </Text>
    </Bar>
  );
}
